/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "wysiwyg-bold-928dadf3--sprite",
  "use": "wysiwyg-bold-928dadf3--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"wysiwyg-bold-928dadf3--sprite\"><g transform=\"translate(0 0)\"><g transform=\"translate(0 0)\"><rect width=\"36\" height=\"36\" rx=\"18\" fill=\"#e0e7f4\" opacity=\"0\" /></g></g><path d=\"M822.677,1270.344a3.1,3.1,0,0,0,.693-1.971,3.153,3.153,0,0,0-3.15-3.15h-2.25a1.805,1.805,0,0,0-1.8,1.8v8.091a1.807,1.807,0,0,0,1.8,1.809h2.7a3.6,3.6,0,0,0,2.007-6.579Zm-4.707-3.321h2.25a1.35,1.35,0,0,1,0,2.7h-2.25Zm2.7,8.109-2.709-.018v-3.591h2.709a1.8,1.8,0,0,1,0,3.609Z\" transform=\"translate(-802.17 -1253.223)\" fill=\"currentColor\" /></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
